import { useCallback, useEffect, useState } from 'react'
import Header from '../../../Header'
import * as styled from '../../../style/main.style'
import Navbar from '../../../Navbar'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import SearchAutocompleteSelect from '../../../../../component/select/searchAutocompleteSelect'
import TableCustom from '../../../../../component/table/tableCustom'
import TableRowCommon from '../../../../../component/table/TableRowCommon'
import { motion } from 'framer-motion'
import { ReportApi } from '../../../../../api/report/report.api';
import { useDispatch, useSelector } from 'react-redux'
import Loading from '../../../../../component/loading/Loading'
import { FiscalYearApi } from '../../../../../api/fiscal-year/fiscalyear.api'
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice'
import { saveAs } from 'file-saver'
import MenuDropdown from '../../../../../component/menu-dropdown/MenuDropdown'
import { DepartMentApi } from '../../../../../api/department/department.api'
import { colors } from '../../../../../constants/colors'


interface Column {
    id: 'name' | 'code' | 'population' | 'size' | 'density';
    label: string;
    minWidth?: number;
    align?: 'right' | 'center';
    format?: (value: number) => string;
}

const ColorfulReport = () => {
    const { t } = useTranslation();
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const dispatch = useDispatch();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalPage, setTotalPage] = useState<number>(2);

    const [dataReport, setDataReport] = useState<any[]>([]);

    const [idFiscalYear, setIdFiscalYear] = useState<number>(0);
    const [idDepartment, setIdDepartment] = useState<number>(Number);


    const headCells = [
        {
            id: "FIR",
            disablePadding: true,
            align: "center",
            width: 100,
            label: "ที่"
        },
        {
            id: "idFiscalYear",
            disablePadding: true,
            align: "center",
            width: 200,
            label: "ปีงบประมาณ"
        },
        {
            id: "strategyName",
            disablePadding: true,
            align: "center",
            width: 300,
            label: "ยุทธศาสตร์"
        },
        {
            id: "Stragy",
            disablePadding: true,
            align: "center",
            width: 300,
            label: "หน่วยงาน"
        },
        {
            id: "PLAN",
            disablePadding: true,
            align: "center",
            width: 300,
            label: "โครงการ"
        },
        {
            id: "result",
            disablePadding: true,
            align: "center",
            width: 200,
            label: "สถานะ"
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { id, fiscalYear, departmentName, strategyName, projectName, projectStatusName, colorCode } =
            objData;

        const objRenderData = {
            key: no,
            id: id,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "center",
                    label: no || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: fiscalYear || "-",

                },
                {
                    option: "TEXT",
                    align: "left",
                    label: strategyName || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: departmentName || "-",
                },
                {
                    option: "TEXT",
                    align: "left",
                    label: projectName || "-",
                },
                {
                    option: "TEXT",
                    align: 'center',
                    label: projectStatusName || "-",
                    style: { backgroundColor: colorCode || "", color: colors.white }
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleGetReport = useCallback(async () => {
        let condition: any = {
            idFiscalYear: idFiscalYear
        }
        if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
        if (idDepartment) condition = { ...condition, idDepartment: idDepartment }
        await ReportApi.getColorfulReport(condition)
            .then(res => {
                if (res.status === 200) {
                    // console.log(res.data?.result)
                    setDataReport(res.data?.result)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [idFiscalYear, idDepartment])

    const handleGetFile = async (format: 'pdf' | 'excel') => {
        try {
            dispatch(setLoading())
            let condition: any = {
                format: format
            }
            if (idFiscalYear) condition = { ...condition, idFiscalYear: idFiscalYear }
            if (idDepartment) condition = { ...condition, idDepartment: idDepartment }
            await ReportApi.getEColorfulReportFile(condition)
                .then(res => {
                    if (res.status === 200) {
                        dispatch(unsetLoading())
                        const data = res?.data
                        if (format === 'pdf') {
                            const blob = new Blob([data], { type: 'application/pdf' });
                            saveAs(blob, 'รายงานความคืบหน้าโครงการ-pdf');
                        } else if (format === 'excel') {
                            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                            saveAs(blob, 'รายงานความคืบหน้าโครงการ-excel');
                        }
                    }
                })
                .catch(error => {
                    dispatch(unsetLoading())
                    console.log(error)
                })
        } catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        handleGetReport();
    }, [handleGetReport])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <motion.div
                        initial={{ x: 100 }}
                        animate={{ x: 0 }}
                        transition={{ ease: "backInOut", stiffness: 100 }}
                        className='w-full h-auto'>
                        <section>
                            <Typography className='text-primary' variant='h4'>
                                {"รายงาน"}
                            </Typography>
                            <Typography variant='h6' className='text-primary mt-3'>
                                {"รายงานความคืบหน้าโครงการ"}
                            </Typography>
                        </section>
                        <section className='w-full mt-8'>
                            <article className='flex flex-col md:flex-row justify-between items-center'>
                                <span className='grid grid-cols-12 gap-2 w-full'>
                                    <span className='col-span-6 md:col-span-4'>
                                        <SearchAutocompleteSelect
                                            headingNormal
                                            heading={t("ปีงบประมาณ")}
                                            labelId="label-fiscal-year"
                                            idKey="idFiscalYear"
                                            value={idFiscalYear}
                                            serverSearch={false}
                                            fetchOptions={(condition) => FiscalYearApi.getFiscalYear(condition)}
                                            getOptionLabel={(option) => String(option?.fiscalYear ?? '')}
                                            statusKey="fiscalYearStatus"
                                            onChange={(id) => setIdFiscalYear(id)}
                                        />
                                    </span>
                                    <span className='col-span-6 md:col-span-4'>
                                        <SearchAutocompleteSelect
                                            headingNormal
                                            heading={t("หน่วยงาน")}
                                            labelId="label-department"
                                            idKey="idDepartment"
                                            value={idDepartment}
                                            fetchOptions={(condition) => DepartMentApi.getDepartments(condition)}
                                            getOptionLabel={(option) => option?.departmentName}
                                            statusKey="departmentStatus"
                                            onChange={(id) => setIdDepartment(id)}
                                        />
                                    </span>
                                </span>
                                <span className='w-full md:w-auto'>
                                    <div className='w-auto flex flex-col self-end gap-2'>
                                        <MenuDropdown
                                            headingNormal
                                            heading='ส่งออกเอกสาร'
                                            buttonName='ดาวน์โหลด'
                                            menuItems={[
                                                { id: 1, name: "pdf", onClick: () => handleGetFile('pdf') },
                                                { id: 2, name: 'excel', onClick: () => handleGetFile('excel') }
                                            ]}
                                        />
                                    </div>
                                </span>

                            </article>
                        </section>
                        <section className='w-full mt-3'>
                            <TableCustom
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy=""
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalPage}
                                rowsData={dataReport && dataReport?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                                hidePagination
                                tableFixedWidth
                            />
                        </section>
                    </motion.div>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default ColorfulReport
